var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGooglePlus = function SvgGooglePlus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7E849D",
    fillRule: "nonzero",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.625 0h-5.25A4.375 4.375 0 0 0 0 4.375v5.25A4.375 4.375 0 0 0 4.375 14h5.25A4.375 4.375 0 0 0 14 9.625v-5.25A4.375 4.375 0 0 0 9.625 0zm3.063 9.625a3.066 3.066 0 0 1-3.063 3.063h-5.25a3.066 3.066 0 0 1-3.063-3.063v-5.25a3.066 3.066 0 0 1 3.063-3.063h5.25a3.066 3.066 0 0 1 3.063 3.063v5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 3.38a3.62 3.62 0 1 0 0 7.241 3.62 3.62 0 0 0 0-7.242zm0 5.883A2.266 2.266 0 0 1 4.737 7 2.265 2.265 0 0 1 7 4.737 2.265 2.265 0 0 1 9.263 7 2.266 2.266 0 0 1 7 9.263z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.621,
    cy: 3.379,
    r: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGooglePlus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-plus.616369b5.svg";
export { ForwardRef as ReactComponent };